import { useContext } from 'react'
import { CashflowEventsContext } from '../context'
import { getFormEventTypeFromState } from './stateHelper'
import messages from '../messages.json'
import { parseNumber } from '../../../utils/numberConversions'
import range from 'lodash/range'

export const onSubmit = () => {
  const formEventType = getFormEventTypeFromState()
  const context = useContext(CashflowEventsContext)
  const { actions } = context
  const { formSubmit } = actions

  return (values) => {
    const valuesWithEventType = {
      ...values,
      event_type: formEventType,
      end_age: values.recurring
        ? values.end_age
        : values.start_age
    }

    formSubmit(valuesWithEventType, context)
  }
}

export const submitJointCashflowEvent = () => {
  const formEventType = getFormEventTypeFromState()
  const context = useContext(CashflowEventsContext)
  const { actions } = context
  const { formSubmit } = actions
  return (values) => {
    const valuesWithEventType = {
      ...values,
      event_type: formEventType,
      end_year: values.recurring
        ? values.end_year
        : values.start_year
    }

    formSubmit(valuesWithEventType, context)
  }
}


export const frequencyOptions = (values, errors) => {
  const errorsExist = values.joint
    ? errors.start_year || errors.end_year
    : errors.start_age || errors.end_age

  if (errorsExist) {
    return []
  } else {
    const range = values.joint
      ? values.end_year - values.start_year
      : values.end_age - values.start_age
    const frequencyOptions = createFrequencyOptionsForRange(range)

    return frequencyOptions
  }
}

const createFrequencyOptionsForRange = (ageRange) => {
  const frequencyOptions = []
  for (const age of range(1, ageRange + 1)) {
    frequencyOptions.push({
      value: parseNumber(age),
      name: age === 1
        ? `${messages.form.frequencyMessages.everyYear}`
        : `${messages.form.frequencyMessages.every} ${age} ${messages.form.frequencyMessages.years}`
    })
  }

  return frequencyOptions
}
